/* Renton: extra interactions and consent-controlled Clarity. Standard commerce
 * events remain owned by Google & YouTube. No contact values or guide answers. */
(function () {
  'use strict';
  var shop = window.Shopify;
  if (!shop || shop.shop !== 'rentonvatten.myshopify.com' || shop.designMode || window.rentonMeasurementReady) return;
  window.rentonMeasurementReady = true;
  var project = document.currentScript.dataset.clarityProject;
  var initialized = false;
  var loaded = !!document.querySelector('script[src*="clarity.ms/tag/"]');

  function claritySignal(analytics, marketing) {
    if (typeof window.clarity !== 'function') return;
    window.clarity('consentv2', {
      analytics_Storage: analytics ? 'granted' : 'denied',
      ad_Storage: marketing ? 'granted' : 'denied'
    });
  }

  function applyConsent(privacy) {
    var analytics = privacy.analyticsProcessingAllowed() === true;
    var marketing = privacy.marketingAllowed() === true;
    if (!analytics) {
      if (!loaded) return;
      claritySignal(false, false);
      // Clarity can restart in cookieless mode when consent changes. Stop after
      // that transition too, unless the visitor has granted analytics again.
      [0, 300, 800, 1600].forEach(function (delay) {
        window.setTimeout(function () {
          if (!privacy.analyticsProcessingAllowed() && typeof window.clarity === 'function' && window.clarity.v) window.clarity('stop');
        }, delay);
      });
      return;
    }
    if (loaded) {
      if (typeof window.clarity === 'function') window.clarity('start', {});
      claritySignal(true, marketing);
      return;
    }
    loaded = true;
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    claritySignal(true, marketing);
    var reconciled = false;
    window.clarity('metadata', function () {
      if (reconciled) return;
      reconciled = true;
      applyConsent(privacy);
    }, false);
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/' + project;
    script.setAttribute('data-renton-clarity', '');
    script.onerror = function () { loaded = false; };
    document.head.appendChild(script);
  }

  function send(name, placement, ctaId, attempts) {
    var privacy = shop.customerPrivacy;
    if (!privacy || !privacy.analyticsProcessingAllowed()) return;
    if (typeof window.gtag !== 'function') {
      if (attempts < 12) window.setTimeout(function () { send(name, placement, ctaId, attempts + 1); }, 250);
      return;
    }
    var parameters = {
      send_to: 'G-71X9KYGL6V',
      theme_id: String(shop.theme.id),
      placement: placement,
      transport_type: 'beacon'
    };
    if (ctaId) parameters.cta_id = ctaId;
    window.gtag('event', name, parameters);
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }

  document.addEventListener('click', function (event) {
    var element = event.target.closest('[data-renton-cta-id], a[href], [data-guide-open], [data-guide-restart]');
    if (!element || element.disabled) return;
    var name;
    var ctaId = element.getAttribute('data-renton-cta-id') || '';
    if (!/^home_[a-z0-9_-]{1,95}$/.test(ctaId)) ctaId = '';
    var href = element.tagName === 'A' ? (element.getAttribute('href') || '') : '';
    if (/^tel:/i.test(href)) name = 'renton_phone_click';
    else if (/^mailto:/i.test(href)) name = 'renton_email_click';
    else if (/\/pages\/offertforfragan(?:[?#]|$)|^#gadd-enquiry-/.test(href)) name = 'renton_quote_click';
    else if (element.hasAttribute('data-guide-open')) name = 'renton_guide_start';
    else if (element.hasAttribute('data-guide-restart')) name = 'renton_guide_restart';
    else if (ctaId) name = 'renton_cta_click';
    if (!name) return;
    var section = element.closest('header, footer, [id^="shopify-section-"], [data-renton-guide]');
    var placement = section ? (section.id || section.tagName.toLowerCase()) : 'page';
    var ctaLocation = element.getAttribute('data-renton-cta-location') || '';
    if (ctaId && /^(hero|water_tests|process|guide|advice|range|knowledge|faq)$/.test(ctaLocation)) placement = ctaLocation;
    send(name, placement.slice(0, 100), ctaId, 0);
  });

  function init() {
    if (initialized) return;
    if (!shop.customerPrivacy) {
      if (typeof shop.loadFeatures === 'function') shop.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) init();
      });
      return;
    }
    initialized = true;
    applyConsent(shop.customerPrivacy);
    document.addEventListener('visitorConsentCollected', function () { applyConsent(shop.customerPrivacy); });
  }
  init();
  if (!initialized) document.addEventListener('DOMContentLoaded', init);
})();
